<template>
  <el-upload 
    action 
    :accept="acceptType" 
    drag
    :class="['uploader', className]"
    multiple 
    ref="uploader"
    :show-file-list="false"
    :http-request="e => uploadHanlder(e)"
    :beforeUpload="file => beforeUpload(file)"
    @drop.native="e => beforeUpload(e.dataTransfer.files[0])"
    >
    <slot :loading="loading">
      <el-button type="primary" size="medium" v-if="type === 'button'" :loading="loading">
        <span v-if="text" v-html="text"></span>
        <template v-else>Browser...</template>
      </el-button>
      <template v-else>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text" v-if="!loading">
          <span v-if="text" v-html="text"></span>
          <template v-else>拖拽文件到此处，或<em>点击上传</em></template>
        </div>
        <div class="el-upload__text" v-else>loading...</div>
        <div class="el-upload__tip" slot="tip" v-show="showTip">仅{{acceptType}}类型的文件，并小于{{size}}</div>
      </template>
    </slot>
  </el-upload>
</template>

<script>
import { FileUpload } from '@/api/index.js'
import { mimeType } from '@/utils/json.js'
export default {
  name: 'default',
  data () {
    return {
      file: null,
      loading: false,
      ts: null
    }
  },
  props: {
    type: {
      type: String,
      required: false,
      default: null
    },
    accept: {
      type: String,
      required: false,
      default: '',
    },
    size: {
      type: String | Number,
      required: false,
      default: '10M',
    },
    showTip: {
      type: Boolean,
      default: false,
      required: false
    },
    text: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    acceptType(){
      let accept = this.accept;
      let result = null;
      if(typeof accept === 'string')
        result = accept;
      else if(Array.isArray(accept))
        result = accept.join(',')
      else try{result = JSON.stringify(accept)}catch(e){}
      if(result) result = result.toLowerCase();
      return result;
    },
    acceptMimeType(){
      let accepts = this.acceptType.split(',');
      let mimes = accepts.map(item => mimeType[item]).filter(item => item)
      let result = mimes.filter(item => !Array.isArray(item));
      let array = mimes.filter(item => Array.isArray(item));
      for(let i in array) result = [...result, ...array[i]];
      return result;
    },
    className(){
      return this.type === 'button' ? 'my-custom-drag-btn': null;
    }
  },
  methods: {
    uploadHanlder({file}){
      if(this.loading) return;
      this.loading = true;
      let formData = new FormData();
      formData.append('file', file);
      FileUpload(formData).then(res => {
        this.loading = false;
        this.$emit('callback', res);
        this.$refs.uploader.clearFiles();
      }).catch(({code, msg}) => {
        this.loading = false;
        this.$refs.uploader.clearFiles();
      })
    },
    beforeUpload(file){
      let ts = new Date().getTime();
      if(this.ts && ts - this.ts <= 50) return;
      this.ts = ts;

      //验证文件大小
      let sizeResult = this.checkFileSize(file.size)
      if(sizeResult){
        this.$message.warning(sizeResult);
        return false;
      }
      let acceptResult = this.checkFileType(file.type);
      if(acceptResult){
        this.$message.warning(acceptResult);
        return false;
      }
      return true;
    },
    checkFileSize(size){
      let acceptSize = this.size;
      if(acceptSize == null || acceptSize == undefined)
        return null;
      
      acceptSize = typeof acceptSize === 'string'? 
        this.strByteTrans(acceptSize) : 
        acceptSize;
      
      if(size <= acceptSize) return;
      else return `上传的文件不能大于${this.strByteTrans(acceptSize)}`;
    },
    strByteTrans(size, type){
      if(typeof size === 'string'){
        let unit = size.replace(/[^a-zA-Z]/g, '');
        let num = size.replace(/[^0-9]/g, '');
        if(!unit) return Number(num);

        unit = unit.toLowerCase();
        let symble = ['bytes,b', 'kb,k', 'mb,m', 'gb,g', 'tb,t', 'pb,p', 'eb,e', 'zb,z', 'yb,y'];
        let index = symble.findIndex(item => item.split(',').indexOf(unit) != -1)
        if(index <= 0) return Number(num);
        else return Math.pow(1024, index) * num;
      }else if(typeof size === 'number'){
        if (isNaN(size)) {
          return '';
        }
        var symbols = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var exp = Math.floor(Math.log(size)/Math.log(2));
        if (exp < 1) {
          exp = 0;
        }
        var i = Math.floor(exp / 10);
        size = size / Math.pow(2, 10 * i);

        if (size.toString().length > size.toFixed(2).toString().length) {
          size = size.toFixed(2);
        }
        return  `${size}${symbols[i]}`;
      }
    },
    checkFileType(type){
      if(!this.acceptType) return;
      if(this.acceptMimeType.indexOf(type) != -1 || !this.acceptMimeType.length) return;
      return `仅能上传${this.acceptType}类型的文件`;
    }
  }
}
</script>

<style lang="scss" scoped>
.my-custom-drag-btn{
  line-height: initial;
  margin-bottom: -2px;
  
  >>> .el-upload-dragger{
    border: 0;
    width: auto;
    height: auto;
    border-radius: 3px;
    transition: box-shadow .2s;
    background-color: transparent;

    .el-button{
      margin: 0;

      .el-icon-upload{
        font-size: 14px;
        margin: 0;
        line-height: 1;
        color: inherit;
      }

      &.is-disabled{
        .el-icon-upload{
          color: inherit;
        }
      }
    }

    &.is-dragover{
      box-shadow: 0 0 8px rgba(0,0,0, .7);
      border: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Uploader.vue